const o = {
  parts: ["item", "link"],
  baseStyle: ({ theme: r }) => ({
    item: {
      color: r.text.deemphasized
    },
    link: {
      ...r.linkDefault
    }
  }),
  variants: {
    singular: ({ theme: r }) => ({
      item: {
        flexDirection: "row-reverse",
        color: r.action.primaryDefault,
        _hover: {
          color: r.action.primaryHover
        },
        _focus: {
          color: r.action.primaryFocus
        },
        _active: {
          color: r.action.primaryPressed
        }
      }
    })
  }
};
export {
  o as default
};
